import { FilterType, type FilterDefinition, type FilterValues, type FilterWithSelection } from "@/services/filter";

/**
 * Merge filter definitions with current selection state for UI rendering.
 */
export function mergeFiltersWithSelection(definitions: FilterDefinition[], values: FilterValues): FilterWithSelection[] {
  return definitions.map((def) => {
    const val = values[def.slug];
    const selectedValue = Array.isArray(val) ? val : (val ?? null);

    // For range filters, extract _min/_max values from URL params
    if (def.type === FilterType.Range) {
      const minStr = values[`${def.slug}_min`];
      const maxStr = values[`${def.slug}_max`];
      const selectedMin = typeof minStr === "string" && minStr !== "" ? Number(minStr) : undefined;
      const selectedMax = typeof maxStr === "string" && maxStr !== "" ? Number(maxStr) : undefined;
      return { ...def, selectedValue, selectedMin, selectedMax };
    }

    return { ...def, selectedValue };
  });
}
